module.exports = __webpack_public_path__ + "static/media/fiskkit_articles.312a2d67.jpg";